import { WalletConnectMoleculeReatom } from "@/app/wallet-connect/store.reatom"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { action, computed } from "@reatom/core"
import { molecule } from "bunshi"
import { NftSearchResultMoleculeReatom } from "../../search/result/store.reatom"
import { NftsToBuyMoleculeReatom } from "../nfts-to-buy/molecule.reatom"
import { isNftAvailableToBuy } from "../nfts-to-buy/utils"

const MAX_NFT_TO_SWEEP = 25

export const SweepMoleculeReatom = molecule((mol) => {
  const { unionAddress } = mol(WalletConnectMoleculeReatom)
  const { nftSearchQueryParamsAtom } = mol(NftSearchResultMoleculeReatom)

  // Factory function to compute available NFTs to sweep from query data
  const nftsAvailableToSweep =
    () => (nfts: NftMiniature[], userWallet: UnionAddress | undefined) => {
      return nfts.filter((nft) => isNftAvailableToBuy(nft, userWallet))
    }

  const { selectedNftsToBuy, setNftsToBuy } = mol(NftsToBuyMoleculeReatom)

  const maxSweep = () => (availableNftsCount: number) => {
    return Math.min(availableNftsCount, MAX_NFT_TO_SWEEP)
  }

  const nftsToSweepCount =
    () => (nftsToBuy: NftMiniature[], allNfts: NftMiniature[]) => {
      let count = 0

      for (const index in nftsToBuy) {
        const nft = allNfts[index]

        /**
         * If first N nfts are not in N selected nfts it means that
         * user has selected them manually or some changes in nft list break the order.
         *
         * So, the counter of sweep should be reset to 0. As it's not a sweep selection.
         */
        if (!nftsToBuy.some(({ id }) => id === nft?.id)) return 0

        count++
      }

      return count
    }

  const selectNftsToSweep = action(
    (nftsAvailable: NftMiniature[], count: number) => {
      const nftsToSweep = nftsAvailable.slice(0, count)
      setNftsToBuy(nftsToSweep)
    },
    "selectNftsToSweep",
  )

  return {
    nftSearchQueryParamsAtom,
    nftsAvailableToSweep,
    nftsToSweepCount,
    selectNftsToSweep,
    maxSweep,
  }
})
